import { authTokenUrl } from "config/paths";

export default {
  signIn: (token, locale) => {
    const fetchOptions = {
      method: "POST",
      body: JSON.stringify({
        token,
        locale,
      }),
      headers: {
        "Content-Type": "application/json",
      },
      mode: "cors",
    };

    return fetch(authTokenUrl, fetchOptions).then(res => {
      if (res.ok) {
        return res.text();
      }
      throw new Error();
    });
  },
};
